"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.create.title': '创建新职业',
};
